import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { TimerStatus } from '../../../../features/calendar/calendar-types';
import * as fromTimerActions from './timer.actions';

@Injectable({
  providedIn: 'root',
})
export class TimerHttpService {
  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
  ) {}

  public postTimer(timerStatus: TimerStatus, taskId: number): Observable<unknown> {
    this.store.dispatch(
      fromTimerActions.postTimer({
        payload: { status: timerStatus, taskId },
      }),
    );

    return this.actions$.pipe(ofType(fromTimerActions.timerPosted), take(1));
  }
}
